import { render, staticRenderFns } from "./SelectPrefecture.vue?vue&type=template&id=5a014dae&"
import script from "./SelectPrefecture.vue?vue&type=script&lang=js&"
export * from "./SelectPrefecture.vue?vue&type=script&lang=js&"
import style0 from "./SelectPrefecture.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SelectPrefecture.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports